export const REDUX_NAMESPACE = 'CLIPBOARD';

export const PASTE_SHOT_LAYOUT_INFO_FROM_CLIPBOARD = Symbol();
